import React from 'react';

import { Badge, BadgeProps } from '@mantine/core';
import { MOVEMENT_TYPE_LABEL_MAP, MovementTypeEnum } from 'types/enums';

const movementTypeColorMap: Record<MovementTypeEnum, string> = {
  [MovementTypeEnum.MOVEMENT]: 'blue',
  [MovementTypeEnum.BENCHMARK]: 'violet',
  [MovementTypeEnum.SCORED_SECTION]: 'gray',
};

// The Type pill for a movement, benchmark or scored section. An unrecognised value keeps
// its raw string so a new backend kind is visible rather than blank.
const MovementTypeBadge = ({
  movementType,
  ...badgeProps
}: BadgeProps & { movementType?: string | null }): JSX.Element | null => {
  if (!movementType) return null;

  const kind = movementType as MovementTypeEnum;
  return (
    <Badge variant='light' color={movementTypeColorMap[kind] ?? 'gray'} {...badgeProps}>
      {MOVEMENT_TYPE_LABEL_MAP[kind] ?? movementType}
    </Badge>
  );
};

export default MovementTypeBadge;
